<template>
  <div class="main">
    <GoBack :name="`卡券专区`" :type="2" :path="`/mobile/home`"></GoBack>

    <!-- //阴影 -->
    <img class="shadow" src="@/assets/mobile/image/common/shadow.png" />

    <div class="img-box">
      <div
        :class="[{ 'flex-item': item.type === active || active >= item.tType }]"
        v-if="item.type === active || active >= item.tType"
        v-for="(item, index) in flexList"
      >
        <img class="bg" :src="item.url" />

        <div class="name">{{ item.name }}</div>

        <div class="tips-box">
          <span>{{ item.tips }}</span>
          <img class="duihao" src="@/assets/image/common/duihao.png" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import GoBack from "@/components/goBack";
import { getAccount } from "@/api/mobile";
export default {
  data() {
    return {
      flexList: [
        {
          url: require("@/assets/image/common/icon1.png"),
          eUrl: require("@/assets/image/common/eicon1.png"),
          name: "30天保护卡",
          ename: "30 days protect",
          tips: "首次完成注册",
          etips: "first register",
          type: 1,
        },
        {
          url: require("@/assets/image/common/icon2.png"),
          eUrl: require("@/assets/image/common/eicon2.png"),
          name: "额外奖励5%",
          ename: "Extra rewards 5%",
          tips: "完成任务",
          etips: "Complete task",
          type: 2,
        },
        {
          url: require("@/assets/image/common/icon2.png"),
          eUrl: require("@/assets/image/common/eicon2.png"),
          name: "额外奖励10%",
          ename: "Extra rewards 10%",
          tips: "完成任务",
          etips: "Complete task",
          type: 3,
        },
        {
          url: require("@/assets/image/common/icon2.png"),
          eUrl: require("@/assets/image/common/eicon2.png"),
          name: "额外奖励15%",
          ename: "Extra rewards 15%",
          tips: "完成任务",
          etips: "Complete task",
          type: 4,
        },
        {
          url: require("@/assets/image/common/icon2.png"),
          eUrl: require("@/assets/image/common/eicon2.png"),
          name: "额外奖励20%",
          ename: "Extra rewards 20%",
          tips: "完成任务",
          etips: "Complete task",
          type: 5,
        },
        {
          url: require("@/assets/image/common/icon2.png"),
          eUrl: require("@/assets/image/common/eicon2.png"),
          name: "额外奖励40%",
          ename: "Extra rewards 40%",
          tips: "完成任务",
          etips: "Complete task",
          type: 6,
        },
        {
          url: require("@/assets/image/common/icon3.png"),
          eUrl: require("@/assets/image/common/eicon3.png"),
          name: "金盾保护卡",
          ename: "Strong protection",
          tips: "完成任务",
          etips: "Complete task",
          tType: 2,
        },
        {
          url: require("@/assets/image/common/icon4.png"),
          eUrl: require("@/assets/image/common/eicon4.png"),
          name: "VIP快速审核通道",
          ename: "VIP channel",
          tips: "完成任务",
          etips: "Complete task",
          tType: 3,
        },
      ],
      userInfo: {},
      grade: 1,
      active: 1,
    };
  },
  components: { GoBack },
  methods: {
    getGrade() {
      if (this.userInfo.credit <= 60) {
        return 1;
      }
      if (61 <= this.userInfo.credit && this.userInfo.credit <= 100) {
        return 2;
      }
      if (101 <= this.userInfo.credit && this.userInfo.credit <= 200) {
        return 3;
      }
      if (201 <= this.userInfo.credit && this.userInfo.credit <= 500) {
        return 4;
      }
      if (501 <= this.userInfo.credit && this.userInfo.credit <= 800) {
        return 5;
      }
      if (801 <= this.userInfo.credit && this.userInfo.credit <= 1000) {
        return 6;
      }
      return 1;
    },
  },
  async created() {
    if (localStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.$store.commit("changeUserInfo", this.userInfo);
    } else {
      await getAccount().then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.$store.commit("changeUserInfo", this.userInfo);
          localStorage.setItem("userInfo", JSON.stringify(res.data));
        }
      });
    }
    this.grade = this.getGrade();
    this.active = this.grade;
  },
};
</script>
<style lang="scss" scoped>
.main {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #ffffff;
  .shadow {
    position: absolute;
    width: 100%;
    top: 0;
    z-index: 0;
  }
  .img-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 12px;
    background-color: #fff;
    .flex-item {
      flex-shrink: 0;
      width: 294px;
      height: 120px;
      position: relative;
      margin-top: 40px;
      border-radius: 4px;
      .bg {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 1;
      }
      .name {
        color: #474f66;
        font-size: 16px;
        font-weight: bolder;
        margin-top: 41px;
        margin-left: 28px;
        position: relative;
        z-index: 2;
      }
      .tips-box {
        display: flex;
        align-items: center;
        position: relative;
        z-index: 2;
        color: #8948ff;
        font-size: 14px;
        font-weight: bolder;
        margin: 5px 0 0 28px;
        img {
          width: 16px;
          height: 16px;
          margin-left: 12px;
        }
      }
    }
  }
}
</style>